module.exports = __webpack_public_path__ + "static/media/adv-test.163dacc0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/social-proof/adv-test.svg
// module id = 2085
// module chunks = 0